import { MouseEventHandler, ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

type Props = {
  isActive?: boolean;
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
};

export const FilterBadge = ({ onClick, children, isActive, isDisabled }: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twJoin(
        'text-xs font-medium inline-flex items-center px-2.5 py-0.5 rounded space-x-2',
        isDisabled && 'cursor-not-allowed',
        isActive
          ? 'bg-blue-100 text-blue-800 dark:bg-gray-700 dark:text-blue-400 border border-blue-400'
          : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-400 border border-gray-500',
      )}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};
